import React from 'react';

class ViewAccesor extends React.Component {
  render() {
    return null;
  }

    getView = () => {
      return this.props.view;
    }
}

export default ViewAccesor;
